module.exports = __webpack_public_path__ + "static/img/bgi.31e64594.png";